export default __webpack_public_path__ + "static/media/search-district-library-preview.ff1570ea.png";